import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';


import API from '../services/api';

export default function PrintDetailPage() {
  const { id }                  = useParams();
  const [record,   setRecord]   = useState(null);
  const [officers, setOfficers] = useState({});
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    API.get(`/maintenance/${id}`).then(async res => {
      const r = res.data;
      setRecord(r);
      const o   = {};
      const ids = [r.opening_officer_id, r.inspection_officer_1_id, r.inspection_officer_2_id].filter(Boolean);
      await Promise.all(ids.map(async oid => {
        try { const r2 = await API.get(`/employees/${oid}`); o[oid] = r2.data; } catch {}
      }));
      setOfficers(o);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    if (!loading && record) setTimeout(() => window.print(), 600);
  }, [loading, record]);

  if (loading) return <div style={{ textAlign: 'center', padding: 40 }}>පූරණය වෙමින්...</div>;
  if (!record)  return <div style={{ textAlign: 'center', padding: 40 }}>වාර්තාව සොයා ගත නොහැකිය</div>;

  const openOfficer = officers[record.opening_officer_id];
  const inspect1    = officers[record.inspection_officer_1_id];
  const inspect2    = officers[record.inspection_officer_2_id];

  const chk  = (val) => val ? 'X' : ' ';
  const fmt  = (n)   => parseFloat(n || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const today = new Date().toISOString().slice(0, 10);

  const typeLabel = () => {
    switch (record.type) {
      case 'system_unit': return 'System Unit';
      case 'monitor':     return 'Monitor';
      case 'printer':     return 'Printer';
      case 'ups':         return 'UPS';
      case 'other':       return `${record.device_name || ''} - ${record.device_description || ''}`;
      default:            return record.type || '';
    }
  };

  // Parse repair_comment as parts to purchase
  const partsToPurchase = record.repair_comment
    ? record.repair_comment.split('\n').map(l => l.trim()).filter(Boolean)
    : [];

  return (
    <>
      <style>{`
        @page { size: A4; margin: 0.8cm; }
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: "Iskoola Pota", Arial, sans-serif; line-height: 1.2; padding: 10px; font-size: 9pt; }
        .container { max-width: 100%; }
        .header { text-align: center; margin-bottom: 15px; }
        .section { margin-bottom: 5px; }
        table { width: 100%; border-collapse: collapse; margin: 3px 0; }
        th, td { border: 1px solid #ddd; padding: 3px; text-align: left; font-size: 9pt; }
        .hardware-details { margin-left: 8px; }
        p { margin: 2px 0; }
        h3 { margin: 3px 0; font-size: 11pt; }
        h4 { margin: 3px 0; font-size: 10pt; }
        .signature-line { border-top: 1px solid black; margin-top: 20px; width: 180px; }
        .no-print { display: none; }
        @media screen {
          .no-print { display: flex; gap: 8px; padding: 10px; background: #f3f4f6; margin-bottom: 10px; }
        }
      `}</style>

      {/* Screen buttons */}
      <div className="no-print">
        <button onClick={() => window.history.back()}
          style={{ background: '#ef4444', color: 'white', border: 'none', padding: '8px 16px', borderRadius: 6, cursor: 'pointer' }}>
          ← ආපසු යන්න
        </button>
        <button onClick={() => window.print()}
          style={{ background: '#3b82f6', color: 'white', border: 'none', padding: '8px 16px', borderRadius: 6, cursor: 'pointer' }}>
          🖨️ මුද්‍රණය
        </button>
      </div>

      <div className="container">

        {/* ── 1. Serial, Inventory, Warranty ── */}
        <div className="section">
          <p>1. අනුක්‍රමික අංකය: {record.serial_number || '________________'}</p>
          <p>2. ඉන්වැන්ට්‍රි අංකය: {record.inventory_number || '________________'}</p>
          <p>3. වගකීම් අවසන් වූ දිනය: {record.warranty_end_date?.slice(0, 10) || '________________'}</p>
        </div>

        {/* ── 4. First service ── */}
        <div className="section">
          <h3>4. ප්‍රථම දෘඩාංග සේවා කිරීම</h3>
          <p>a. විවෘත කළ දිනය: {record.opened_date?.slice(0, 10)}</p>
          <p>b. විවෘත කිරීමට හේතුව: {record.opening_reason}</p>
          <p>c. විවෘත කළ නිලධාරියාගේ</p>
          <table>
            <tbody>
              <tr><th>නම</th><th>තනතුර</th><th>රාජකාරි ලිපිනය</th></tr>
              {openOfficer && (
                <tr>
                  <td>{openOfficer.nama}</td>
                  <td>{openOfficer.thanathura}</td>
                  <td>{openOfficer.lipinaya}</td>
                </tr>
              )}
              {inspect1 && (
                <tr>
                  <td>{inspect1.nama}</td>
                  <td>{inspect1.thanathura}</td>
                  <td>{inspect1.lipinaya}</td>
                </tr>
              )}
              {inspect2 && (
                <tr>
                  <td>{inspect2.nama}</td>
                  <td>{inspect2.thanathura}</td>
                  <td>{inspect2.lipinaya}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* ── 5. Device type ── */}
        <div className="section">
          <h3>5. පරිගණක සම්බන්ධ අලුත් වැඩියා කිරීමට ඇත්තේ</h3>
          <div className="hardware-details">
            <p>වර්ගය: {typeLabel()}</p>
          </div>
        </div>

        {/* ── System Unit Specs ── */}
        {record.type === 'system_unit' && (
          <>
            <div className="section">
              <h3>6. මව්පුවරුවේ</h3>
              <div className="hardware-details">
                <p>a. වර්ගය: {record.motherboard_type}</p>
                <p>b. අනුක්‍රමික අංකය: {record.motherboard_serial}</p>
              </div>
            </div>

            <div className="section">
              <h3>7. Processor</h3>
              <div className="hardware-details">
                <p>a. වර්ගය: {record.processor_type}</p>
                <p>b. අනුක්‍රමික අංකය: {record.processor_serial}</p>
                <p>c. Number of cores: {record.processor_cores}</p>
                <p>d. 1st core speed: {record.core_speed_1}</p>
                <p>e. 2nd core speed: {record.core_speed_2}</p>
                <p>f. With cooling fan [{chk(record.has_cooling_fan)}]</p>
              </div>
            </div>

            <div className="section">
              <h3>8. CD/DVD</h3>
              <div className="hardware-details">
                <p>a. වර්ගය: {record.cd_type}</p>
                <p>b. CD Rom/speeds: {record.cd_rom_speed}</p>
                <p>c. CD Write/Speeds: {record.cd_write_speed}</p>
                <p>d. CD/DVD Combo/Speeds: {record.cd_dvd_combo_speed}</p>
                <p>e. DVD Writer/Speeds: {record.dvd_writer_speed}</p>
                <p>f. අනුක්‍රමික අංකය: {record.cd_serial}</p>
              </div>
            </div>

            <div className="section">
              <h3>9. FDD</h3>
              <div className="hardware-details">
                <p>වර්ගය: {record.fdd_type}</p>
              </div>
            </div>

            <div className="section">
              <h3>10. RAM</h3>
              <div className="hardware-details">
                <p>a. SD/Capacity: {record.sd_capacity}</p>
                <p>b. DDR1/Capacity: {record.ddr1_capacity}</p>
                <p>c. DDR2/Capacity: {record.ddr2_capacity}</p>
                <p>d. DDR3/Capacity: {record.ddr3_capacity}</p>
              </div>
            </div>

            <div className="section">
              <h3>11. Power Unit</h3>
              <div className="hardware-details">
                <p>a. AT [{chk(record.has_at)}]</p>
                <p>b. ATX - 20 pins [{chk(record.has_atx_20pin)}]</p>
                <p>c. ATX - 24 pins [{chk(record.has_atx_24pin)}]</p>
              </div>
            </div>

            <div className="section">
              <h3>12. Casing</h3>
              <div className="hardware-details">
                <p>Type: {record.casing_type?.replace('_', ' ')}</p>
              </div>
            </div>
          </>
        )}

        {/* ── 13. Required parts ── */}
        <div className="section">
          <h3>13. අවශ්‍ය අමතර කොටස්</h3>
          <table>
            <tbody>
              <tr><th>නම</th><th>වර්ගය</th><th>විස්තරය</th></tr>
              <tr><td></td><td></td><td></td></tr>
              <tr><td></td><td></td><td></td></tr>
            </tbody>
          </table>
        </div>

        {/* ── 14. Final report ── */}
        <div className="section">
          <h3>14. අවසන් වාර්තාව</h3>
          <div className="hardware-details">
            {record.status === 'fixed' && (
              <p>[X] මෙම උපකරණය සම්පූර්ණ වශයෙන් යථා තත්ත්වයට පත් කර ඇත</p>
            )}
            {record.status === 'needs_parts' && (
              <>
                <p>[X] උපකරණය පහත සඳහන් උපාංග මිලදී ගෙන සවිකිරීමෙන් යථා තත්ත්වයට පත් කර ගත හැකිය</p>
                <table style={{ marginTop: 5 }}>
                  <tbody>
                    <tr><th>නම</th><th>පිරිවිතර</th></tr>
                    {partsToPurchase.length > 0 ? (
                      partsToPurchase.map((part, i) => {
                        const [name, spec] = part.includes('|') ? part.split('|') : [part, ''];
                        return (
                          <tr key={i}>
                            <td>{name}</td>
                            <td>{spec}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <>
                        <tr><td></td><td></td></tr>
                        <tr><td></td><td></td></tr>
                      </>
                    )}
                  </tbody>
                </table>
              </>
            )}
            {record.status === 'unusable' && (
              <p>මෙම උපකරණය භාවිත කළ නොහැක [X]</p>
            )}
          </div>
        </div>

        {/* ── 15. Additional info ── */}
        <div className="section">
          <h3>15. අතිරේක තොරතුරු</h3>
          <p>a. පාසල ලබාදුන් අංකය: {record.school_assigned_number}</p>
          <p>b. තක්සේරු මිල: Rs. {fmt(record.estimated_value)}</p>
          {record.repair_comment && (
            <p>c. අමතර සටහන්: {record.repair_comment}</p>
          )}
        </div>

        {/* ── Inspection signatures ── */}
        <div className="section">
          <p>විවෘත කිරීමේ සුපරීක්ෂණය</p>
          <table>
            <tbody>
              <tr>
                <td>විදුහල්පති</td>
                <td>................................</td>
                <td>...........................</td>
              </tr>
              <tr>
                <td>පරිගණක විද්‍යාගාරය භාර ගුරු භවතා</td>
                <td>................................</td>
                <td>...........................</td>
              </tr>
              <tr>
                <td>පාසලේ වෙනත් ගුරුවරයෙකු 1</td>
                <td>................................</td>
                <td>...........................</td>
              </tr>
              <tr>
                <td>පාසලේ වෙනත් ගුරුවරයෙකු 2</td>
                <td>................................</td>
                <td>...........................</td>
              </tr>
              <tr>
                <td>පාසලේ සිසු දරුවන් 1</td>
                <td>................................</td>
                <td>...........................</td>
              </tr>
              <tr>
                <td>පාසලේ සිසු දරුවන් 2</td>
                <td>................................</td>
                <td>...........................</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* ── Final signature ── */}
        <div className="section" style={{ marginTop: 10 }}>
          <p>ඉහත තොරතුරු සත්‍ය බව ප්‍රකාශ කරමි.</p>
          <p>දිනය: {today}</p>
          <div style={{ marginTop: 20 }}>
            <div className="signature-line"></div>
            <p>විදුහල්පති අත්සන සහ නිල මුද්‍රාව</p>
          </div>
        </div>

      </div>
    </>
  );
}